/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelBrokerageMovements.ts            *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const AutogenUserSavedSearchEndpoint = "lme/general/brokerage_movements";

export class AutogenModelBrokerageMovements<RowType extends ModelRow> extends Endpoint<RowType, RowBrokerageMovementsFields> {
    constructor(ctor: RowConstructor) {
        super(AutogenUserSavedSearchEndpoint, ctor);
    }
}

export class AutogenRowBrokerageMovements extends ModelRow<RowBrokerageMovementsFields> {
    constructor() {
        super(AutogenUserSavedSearchEndpoint);
    }
}

export interface RowBrokerageMovementsFields {
}

